import { render, staticRenderFns } from "./ChatItemSequence.vue?vue&type=template&id=6c7d8eb8&"
import script from "./ChatItemSequence.vue?vue&type=script&lang=js&"
export * from "./ChatItemSequence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports